// Material UI
import { Box, Paper, Typography, Icon } from '@mui/material';

const SectionCard = ({ number, icon, title, children }) => (
  <Paper
    elevation={0}
    sx={{ borderRadius: 3, overflow: 'hidden', mb: 3, border: '1px solid #dde4ee' }}
  >
    <Box
      sx={{
        px: 3, py: 1.5,
        backgroundColor: '#0041a0',
        display: 'flex', alignItems: 'center', gap: 1.5,
      }}
    >
      <Box
        sx={{
          width: 28, height: 28, borderRadius: '50%',
          backgroundColor: 'rgba(255,255,255,0.2)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}
      >
        <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '0.8rem', lineHeight: 1 }}>
          {number}
        </Typography>
      </Box>
      <Icon sx={{ color: 'rgba(255,255,255,0.85)', fontSize: 20 }}>{icon}</Icon>
      <Typography variant="subtitle1" sx={{ color: '#fff', fontWeight: 600, letterSpacing: 0.3 }}>
        {title}
      </Typography>
    </Box>
    <Box sx={{ p: { xs: 2, sm: 3 }, backgroundColor: '#fff' }}>
      {children}
    </Box>
  </Paper>
);

export default SectionCard;
